import { deserialize, custom, list, object } from 'serializr';
import ResourceBase from './../../../shared/resource-base';
import TimelineEventModel from './../../steps/timeline/timeline-event-model';
import ModelSchemas from './../../../shared/model-schema';

const customSchema = custom(
    jsonValue => jsonValue,
    (jsonValue, callback, context, currentPropertyValue) => {
        return jsonValue;
    }
);

export default class TimelineEventResource extends ResourceBase {
    constructor() {
        super(TimelineEventModel);
        this.schema = ModelSchemas.createTimelineEventSchema(TimelineEventModel, {
            reminders: customSchema,
            recurrences: customSchema,
        });
    }

    getTimelineEventForState(token, state) {
        return this.find(token, { filter: { where: { state: state } } }).then(timelineEventsJSON => {
            const eventModels = [];

            timelineEventsJSON.forEach(eventJSON => {
                eventModels.push(deserialize(this.schema, eventJSON));
            });

            return eventModels;
        });
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-event-resource.js